import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IForward, IForwardModal } from '../types/eecs-forwards.types';

interface ForwardInitialState extends BaseDataReducerInitialState<IForward> {
  selectedForward: IForward | null;
  currentModal: IForwardModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IForward, ForwardInitialState>('eecs-forward');

const eecsForwardInitialState: ForwardInitialState = {
  ...initialState,
  perPage: 25,
  selectedForward: null,
  currentModal: null,
};

export const eecsForward = createSlice({
  name: 'eecsForward',
  initialState: eecsForwardInitialState,
  reducers: {
    setSelectedForward: (state, action: PayloadAction<IForward | null>) => {
      state.selectedForward = action.payload;
    },
    setForwardModal: (state, action: PayloadAction<IForwardModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as ForwardInitialState, action);
    });
  },
});

export const EecsForwardAC = AC;
export const onEecsForwardSort = thunks.onSort;
export const onEecsForwardFilter = thunks.onFilter;
export const setEecsForwardCurrentPage = AC.setCurrentPage;

export const { setForwardModal, setSelectedForward } = eecsForward.actions;
